import type { ReactNode } from "react";
import { Loader2 } from "lucide-react";
import { Modal } from "../../components/ui/modal";

export function ConfirmDialog({
  title,
  children,
  confirmLabel,
  busy = false,
  danger = false,
  onConfirm,
  onClose,
}: {
  title: string;
  children: ReactNode;
  confirmLabel: string;
  busy?: boolean;
  danger?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}) {
  return (
    <Modal
      title={title}
      onClose={() => { if (!busy) onClose(); }}
      width="max-w-md"
      footer={(
        <>
          <button type="button" onClick={onClose} disabled={busy} className="rounded-lg border border-line px-4 py-2 text-sm font-semibold text-ink hover:bg-soft disabled:opacity-50">
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={busy}
            className={`inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold text-white disabled:opacity-50 ${danger ? "bg-danger" : "bg-brand hover:bg-brand-hover"}`}
          >
            {busy ? <Loader2 className="h-4 w-4 animate-spin" aria-hidden /> : null}
            {confirmLabel}
          </button>
        </>
      )}
    >
      <div className="space-y-2 text-sm leading-relaxed text-ink-2">{children}</div>
    </Modal>
  );
}
